const validatePaymentMethod = (paymentMethod) => {
  if (paymentMethod.checkNumber?.length > 10)
    return ["Check number cannot exceed 10 digits."]

  return null
}

export default validatePaymentMethod
